import { buyerRegistrationService, publisherRegistrationService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';
import {
  LOAD_BRP_SETTINGS,
  SAVE_BRP_SETTINGS,
  LOAD_PRP_SETTINGS,
  SAVE_PRP_SETTINGS
} from './actionTypes';

import {
  SET_LOADED_BRP_SETTINGS,
  SET_HAS_DEFAULT_BRP_SETTING,
  SET_LOADED_PRP_SETTINGS,
  SET_HAS_DEFAULT_PRP_SETTING
} from './mutationTypes';

function _createDefaultBRP() {
  return {
    name: 'Default',
    enabled: false,
    description: '',
    contactEmail: '',
    termsAndConditions: '',
    isTermsAndConditionsURL: false,
    requireAgreementToTerms: false
  };
}
function _createDefaultPRP() {
  return {
    name: 'Default',
    enabled: false,
    description: '',
    contactEmail: '',
    termsAndConditions: '',
    isTermsAndConditionsURL: false,
    requireAgreementToTerms: false
  };
}

const actions = {
  async [LOAD_BRP_SETTINGS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: LOAD_BRP_SETTINGS });
    try {
      const response = await buyerRegistrationService.getDefaultBRP(rootState.currentAccountId);

      commit(SET_HAS_DEFAULT_BRP_SETTING);
      commit(SET_LOADED_BRP_SETTINGS, response.data.buyerRegistrationPage);

      commit(SET_ACTION_STATUS_SUCCESS, { actionName: LOAD_BRP_SETTINGS });
    } catch (error) {

      commit(SET_LOADED_BRP_SETTINGS, _createDefaultBRP());

      // We get 404 back when default PRP does not exist  
      if(error.status == 404) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: LOAD_BRP_SETTINGS });
      } else {
        commit(SET_ACTION_STATUS_ERROR, { actionName: LOAD_BRP_SETTINGS, error: error });
      }
    }
  },
  async [LOAD_PRP_SETTINGS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: LOAD_PRP_SETTINGS });
    try {
      const response = await publisherRegistrationService.getDefaultPRP(rootState.currentAccountId);

      commit(SET_HAS_DEFAULT_PRP_SETTING);
      commit(SET_LOADED_PRP_SETTINGS, response.data.publisherRegistrationPage);

      commit(SET_ACTION_STATUS_SUCCESS, { actionName: LOAD_PRP_SETTINGS });
    } catch (error) {

      commit(SET_LOADED_PRP_SETTINGS, _createDefaultPRP());

      // We get 404 back when default PRP does not exist  
      if(error.status == 404) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: LOAD_PRP_SETTINGS });
      } else {
        commit(SET_ACTION_STATUS_ERROR, { actionName: LOAD_PRP_SETTINGS, error: error });
      }
    }
  },

  async [SAVE_BRP_SETTINGS]({ rootState, state, commit }, brpSetting) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: SAVE_BRP_SETTINGS });
    try {

      if (state.noDefaultBrpSetting) {
        await buyerRegistrationService.createBRP(rootState.currentAccountId, brpSetting, true);
      } else {
        await buyerRegistrationService.updateBRP(rootState.currentAccountId, brpSetting);
      }

      commit(SET_ACTION_STATUS_SUCCESS, { actionName: SAVE_BRP_SETTINGS });
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: SAVE_BRP_SETTINGS, error: error });
    }
  },
  async [SAVE_PRP_SETTINGS]({ rootState, state, commit }, prpSetting) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: SAVE_PRP_SETTINGS });
    try {

      if (state.noDefaultPrpSetting) {
        await publisherRegistrationService.createPRP(rootState.currentAccountId, prpSetting, true);
      } else {
        await publisherRegistrationService.updatePRP(rootState.currentAccountId, prpSetting);
      }

      commit(SET_ACTION_STATUS_SUCCESS, { actionName: SAVE_PRP_SETTINGS });
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: SAVE_PRP_SETTINGS, error: error });
    }
  },
};

export default actions;